module.exports = __webpack_public_path__ + "static/media/IMAGE-MOBILE.3697bd48.png";